var _g, _g2, _circle, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatinumCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2496_2476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 52,
    fill: "black",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2496_2476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 36,
    fill: "url(#paint0_linear_2496_2476)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 37,
    stroke: "url(#paint1_linear_2496_2476)",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2496_2476",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 72,
    height: 72
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 36,
    fill: "#CECECE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2496_2476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 23,
    fill: "url(#paint2_linear_2496_2476)",
    stroke: "url(#paint3_linear_2496_2476)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2496_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3185 44.0225L62.625 44.6327H62.6254C62.7062 44.6441 62.782 44.6773 62.8444 44.7286C62.9068 44.7798 62.9533 44.8471 62.9785 44.9227C63.0038 44.9983 63.0068 45.0793 62.9873 45.1566C62.9678 45.2338 62.9266 45.3042 62.8682 45.3598L59.7508 48.3243L60.4866 52.5034C60.5 52.5817 60.4907 52.6621 60.4598 52.7355C60.4289 52.8089 60.3776 52.8725 60.3116 52.919C60.2456 52.9656 60.1676 52.9932 60.0864 52.9989C60.0052 53.0046 59.924 52.9881 59.8519 52.9512L56 50.9772L52.1481 52.9512C52.076 52.9881 51.9947 53.0046 51.9135 52.9989C51.8323 52.9932 51.7543 52.9656 51.6884 52.919C51.6224 52.8725 51.5711 52.8089 51.5401 52.7355C51.5092 52.6621 51.4999 52.5817 51.5133 52.5034L52.2483 48.3209L49.1317 45.3598C49.0734 45.3042 49.0321 45.2337 49.0126 45.1565C48.9932 45.0792 48.9963 44.9982 49.0216 44.9225C49.0469 44.8469 49.0934 44.7797 49.1558 44.7284C49.2183 44.6772 49.2942 44.6441 49.375 44.6327L53.684 44.0225L55.6089 40.2186C55.6491 40.1521 55.7065 40.0969 55.7753 40.0585C55.8441 40.0202 55.922 40 56.0013 40C56.0806 40 56.1585 40.0202 56.2273 40.0585C56.2961 40.0969 56.3535 40.1521 56.3937 40.2186L58.3185 44.0225ZM54.625 57.6327L50.3185 57.0225L48.3937 53.2186C48.3535 53.1521 48.2961 53.0969 48.2273 53.0585C48.1585 53.0202 48.0806 53 48.0013 53C47.922 53 47.8441 53.0202 47.7753 53.0585C47.7065 53.0969 47.6491 53.1521 47.6089 53.2186L45.684 57.0225L41.375 57.6327C41.2942 57.6441 41.2183 57.6772 41.1558 57.7284C41.0934 57.7797 41.0469 57.8469 41.0216 57.9225C40.9963 57.9982 40.9932 58.0792 41.0126 58.1565C41.0321 58.2337 41.0734 58.3042 41.1317 58.3598L44.2483 61.3209L43.5133 65.5034C43.4999 65.5817 43.5092 65.6621 43.5401 65.7355C43.5711 65.8089 43.6224 65.8725 43.6884 65.919C43.7543 65.9656 43.8323 65.9932 43.9135 65.9989C43.9947 66.0046 44.076 65.9881 44.1481 65.9512L48 63.9772L51.8519 65.9512C51.924 65.9881 52.0052 66.0046 52.0864 65.9989C52.1676 65.9932 52.2456 65.9656 52.3116 65.919C52.3776 65.8725 52.4289 65.8089 52.4598 65.7355C52.4907 65.6621 52.5 65.5817 52.4866 65.5034L51.7508 61.3243L54.8682 58.3598C54.9266 58.3042 54.9678 58.2338 54.9873 58.1566C55.0068 58.0793 55.0038 57.9983 54.9785 57.9227C54.9533 57.8471 54.9068 57.7798 54.8444 57.7286C54.782 57.6773 54.7062 57.6441 54.6254 57.6327H54.625ZM70.625 57.6327L66.3185 57.0225L64.3937 53.2186C64.3535 53.1521 64.2961 53.0969 64.2273 53.0585C64.1585 53.0202 64.0806 53 64.0013 53C63.922 53 63.8441 53.0202 63.7753 53.0585C63.7065 53.0969 63.6491 53.1521 63.6089 53.2186L61.684 57.0225L57.375 57.6327C57.2942 57.6441 57.2183 57.6772 57.1558 57.7284C57.0934 57.7797 57.0469 57.8469 57.0216 57.9225C56.9963 57.9982 56.9932 58.0792 57.0126 58.1565C57.0321 58.2337 57.0734 58.3042 57.1317 58.3598L60.2483 61.3209L59.5133 65.5034C59.4999 65.5817 59.5092 65.6621 59.5401 65.7355C59.5711 65.8089 59.6224 65.8725 59.6884 65.919C59.7543 65.9656 59.8323 65.9932 59.9135 65.9989C59.9947 66.0046 60.076 65.9881 60.1481 65.9512L64 63.9772L67.8519 65.9512C67.924 65.9881 68.0052 66.0046 68.0864 65.9989C68.1676 65.9932 68.2456 65.9656 68.3116 65.919C68.3776 65.8725 68.4289 65.8089 68.4598 65.7355C68.4907 65.6621 68.5 65.5817 68.4866 65.5034L67.7508 61.3243L70.8682 58.3598C70.9266 58.3042 70.9678 58.2338 70.9873 58.1566C71.0068 58.0793 71.0038 57.9983 70.9785 57.9227C70.9533 57.8471 70.9068 57.7798 70.8444 57.7286C70.782 57.6773 70.7062 57.6441 70.6254 57.6327H70.625Z",
    fill: "url(#paint4_linear_2496_2476)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 21C55.4473 21 55 21.4478 55 22V26C55 26.5522 55.4473 27 56 27C56.5527 27 57 26.5522 57 26V22C57 21.4478 56.5527 21 56 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 81C55.4473 81 55 81.4478 55 82V86C55 86.5522 55.4473 87 56 87C56.5527 87 57 86.5522 57 86V82C57 81.4478 56.5527 81 56 81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 54C23 54.5522 23.4473 55 24 55H28C28.5527 55 29 54.5522 29 54C29 53.4478 28.5527 53 28 53H24C23.4473 53 23 53.4478 23 54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 54C83 54.5522 83.4473 55 84 55H88C88.5527 55 89 54.5522 89 54C89 53.4478 88.5527 53 88 53H84C83.4473 53 83 53.4478 83 54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.541 22.1245C64.0068 21.9817 63.459 22.2981 63.3154 22.8315L62.2803 26.6953C62.2559 26.7866 62.2451 26.8784 62.2461 26.9685C62.2471 27.0686 62.2637 27.1667 62.2939 27.26L62.3174 27.325C62.3418 27.386 62.3721 27.4446 62.4082 27.4998C62.4717 27.5972 62.5518 27.6836 62.6465 27.7544C62.7461 27.8289 62.8604 27.886 62.9873 27.9202C63.5215 28.063 64.0693 27.7463 64.2129 27.2129L65.248 23.3494C65.293 23.1816 65.292 23.0125 65.2539 22.855C65.1699 22.5112 64.9062 22.2227 64.541 22.1245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1074 80.2817C47.957 80.4089 47.8418 80.582 47.7871 80.7871L46.751 84.6509C46.6084 85.1843 46.9248 85.7327 47.459 85.8757C47.9922 86.0186 48.54 85.7019 48.6836 85.1685L49.7188 81.3049C49.749 81.1931 49.7588 81.0806 49.75 80.9712C49.7402 80.8459 49.707 80.7249 49.6543 80.6138C49.5322 80.3599 49.3047 80.1587 49.0117 80.0801C48.6826 79.9919 48.3486 80.0781 48.1074 80.2817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2061 46.1843C24.2656 46.2974 24.3467 46.3987 24.4453 46.4822C24.5537 46.5742 24.6836 46.6443 24.8311 46.6838L28.6943 47.719C28.9512 47.7878 29.2119 47.75 29.4287 47.6328C29.5439 47.5706 29.6475 47.4856 29.7314 47.3823C29.8174 47.2769 29.8828 47.1519 29.9199 47.012C30.0625 46.4785 29.7461 45.9302 29.2129 45.7871L25.3486 44.752C24.8154 44.6089 24.2666 44.9255 24.124 45.459C24.0566 45.7124 24.0928 45.9692 24.2061 46.1843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0791 60.9883C81.9365 61.5217 82.2529 62.0701 82.7871 62.2129L86.6504 63.2483C86.8379 63.2986 87.0273 63.292 87.2002 63.239C87.2998 63.2087 87.3936 63.1631 87.4785 63.1042C87.667 62.9741 87.8115 62.7793 87.875 62.541C87.9531 62.2495 87.8936 61.9536 87.7373 61.7217C87.6074 61.5293 87.4102 61.3811 87.168 61.3164L83.3047 60.281C82.7705 60.1382 82.2227 60.4548 82.0791 60.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7871 38.866C27.3086 38.5898 27.1445 37.9783 27.4209 37.5C27.6973 37.0217 28.3086 36.8579 28.7871 37.134L32.251 39.134C32.4395 39.2427 32.5791 39.4031 32.6621 39.5869C32.79 39.8704 32.7852 40.2097 32.6172 40.5C32.3408 40.9783 31.7295 41.1421 31.251 40.866L27.7871 38.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.748 68.866C79.2705 68.5898 79.1064 67.9783 79.3828 67.5C79.6582 67.0217 80.2705 66.8579 80.748 67.134L84.2129 69.134C84.4717 69.2834 84.6377 69.531 84.6924 69.8025C84.7393 70.0327 84.7051 70.2805 84.5781 70.5C84.3027 70.9783 83.6904 71.1421 83.2129 70.866L79.748 68.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8662 82.2129C40.5898 82.6912 39.9785 82.855 39.5 82.5789C39.0215 82.3027 38.8574 81.6912 39.1338 81.2129L41.1338 77.7488C41.4102 77.2705 42.0215 77.1064 42.5 77.3828C42.9785 77.6589 43.1416 78.2705 42.8662 78.7488L40.8662 82.2129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1289 30.7429C69.9189 30.7708 69.6982 30.7319 69.5 30.6174C69.3701 30.5422 69.2637 30.4424 69.1826 30.3274C69.127 30.2476 69.083 30.1602 69.0518 30.0686C68.9639 29.8064 68.9844 29.5095 69.1338 29.2512L71.1338 25.7871C71.4102 25.3088 72.0215 25.145 72.5 25.4211C72.9775 25.6973 73.1416 26.3088 72.8662 26.7871L70.8662 30.2512C70.7041 30.5312 70.4268 30.7036 70.1289 30.7429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.666 30.6655C32.3945 30.9368 32.3115 31.3252 32.417 31.668C32.4639 31.8186 32.5469 31.9604 32.666 32.0796L35.4941 34.9082C35.627 35.0408 35.7871 35.1284 35.957 35.1709C36.0615 35.1973 36.1699 35.2063 36.2773 35.1982C36.5068 35.1807 36.7324 35.084 36.9082 34.9082C36.9893 34.8267 37.0537 34.7344 37.1016 34.636C37.1406 34.5562 37.168 34.4719 37.1846 34.3862C37.1973 34.3171 37.2031 34.2471 37.2012 34.1772C37.1953 33.9292 37.0977 33.6831 36.9082 33.4939L34.0801 30.6655C33.6895 30.2749 33.0557 30.2749 32.666 30.6655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0918 73.0918C74.9307 73.2529 74.8359 73.4551 74.8076 73.6648C74.7812 73.865 74.8145 74.0718 74.9092 74.2554C74.9551 74.3457 75.0166 74.4304 75.0918 74.5061L77.9209 77.3345C78.3105 77.7251 78.9443 77.7251 79.335 77.3345C79.7256 76.9441 79.7256 76.3108 79.335 75.9204L76.5059 73.0918C76.4346 73.0203 76.3555 72.9619 76.2705 72.9167C76.1807 72.8691 76.0859 72.8359 75.9893 72.8171C75.6748 72.7563 75.3359 72.8479 75.0918 73.0918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.666 77.3345C33.0557 77.7251 33.6895 77.7251 34.0801 77.3345L36.9082 74.5061C37.0264 74.3879 37.1094 74.2478 37.1562 74.0986C37.1924 73.9819 37.2061 73.8599 37.1992 73.7388C37.1855 73.5032 37.0879 73.2717 36.9082 73.0918C36.5176 72.7014 35.8848 72.7014 35.4941 73.0918L32.666 75.9204C32.2754 76.3108 32.2754 76.9441 32.666 77.3345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0918 34.9082C75.4824 35.2986 76.1152 35.2986 76.5059 34.9082L79.335 32.0796C79.7256 31.6892 79.7256 31.0559 79.335 30.6655C78.9443 30.2749 78.3105 30.2749 77.9199 30.6655L75.0918 33.4939C74.8945 33.6914 74.7969 33.9507 74.7988 34.2092C74.8008 34.4624 74.8984 34.7151 75.0918 34.9082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1338 26.7871C38.8574 26.3088 39.0215 25.6973 39.5 25.4211C39.9785 25.145 40.5898 25.3088 40.8662 25.7871L42.8662 29.2512C43.1416 29.7295 42.9785 30.3411 42.5 30.6172C42.0215 30.8936 41.4102 30.7295 41.1338 30.2512L39.1338 26.7871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1338 78.7488C68.8574 78.2705 69.0215 77.6587 69.5 77.3826C69.9785 77.1064 70.5898 77.2705 70.8662 77.7488L72.8662 81.2129C73.1416 81.6912 72.9785 82.3027 72.5 82.5789C72.0215 82.855 71.4102 82.6912 71.1338 82.2129L69.1338 78.7488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9258 70.9329C27.7207 70.8535 27.54 70.7058 27.4209 70.5C27.1445 70.0217 27.3086 69.4102 27.7871 69.134L31.251 67.134C31.7295 66.8579 32.3408 67.0217 32.6172 67.5C32.8936 67.9783 32.7295 68.5898 32.251 68.866L28.7871 70.866C28.5146 71.0232 28.1982 71.0378 27.9258 70.9329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.748 40.866C80.2705 41.1421 79.6582 40.9783 79.3828 40.5C79.1064 40.0217 79.2705 39.4102 79.748 39.134L83.2129 37.134C83.4336 37.0063 83.6836 36.9729 83.916 37.021C84.1855 37.0769 84.4307 37.2432 84.5781 37.5C84.8545 37.9783 84.6904 38.5898 84.2129 38.866L80.748 40.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.459 22.1245C46.9248 22.2673 46.6084 22.8157 46.751 23.3494L47.7871 27.2129C47.9297 27.7463 48.4775 28.063 49.0117 27.9202C49.5449 27.7771 49.8613 27.2288 49.7188 26.6953L48.6836 22.8315C48.6191 22.592 48.4727 22.396 48.2832 22.2659C48.0508 22.1062 47.7529 22.0457 47.459 22.1245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9873 80.0801C62.4541 80.2229 62.1377 80.7712 62.2803 81.3047L63.3154 85.1685C63.3965 85.4697 63.6064 85.7017 63.8701 85.8208C64.0732 85.9128 64.3086 85.9377 64.541 85.8755C64.8457 85.7939 65.0791 85.5798 65.1973 85.3118C65.2861 85.1106 65.3096 84.8794 65.248 84.6509L64.2129 80.7871C64.0693 80.2537 63.5215 79.937 62.9873 80.0801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.124 62.541C24.2666 63.0745 24.8154 63.3911 25.3486 63.2483L29.2129 62.2129C29.7461 62.0701 30.0625 61.5217 29.9199 60.9883C29.8438 60.7046 29.6533 60.4824 29.4111 60.3579C29.1982 60.248 28.9453 60.2141 28.6953 60.281L24.8311 61.3164C24.2979 61.4592 23.9814 62.0076 24.124 62.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7432 47.7063C82.9189 47.7625 83.1123 47.7705 83.3047 47.719L87.168 46.6838C87.7012 46.5408 88.0186 45.9924 87.875 45.459C87.7324 44.9255 87.1836 44.6089 86.6504 44.752L82.7871 45.7871C82.2529 45.9302 81.9365 46.4785 82.0791 47.012C82.1709 47.3535 82.4287 47.6064 82.7432 47.7063Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 40,
    cy: 15,
    r: 46,
    fill: "url(#paint5_linear_2496_2476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2496_2476",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2496_2476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2496_2476",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2496_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2496_2476",
    x: 12,
    y: 16,
    width: 88,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2496_2476"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2496_2476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2496_2476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2496_2476",
    x: 39,
    y: 39,
    width: 34,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2496_2476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2496_2476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2496_2476",
    x1: 56,
    y1: 18,
    x2: 56.5,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3033",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2496_2476",
    x1: 56,
    y1: 18,
    x2: 56,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2496_2476",
    x1: 56,
    y1: 30,
    x2: 56,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75777A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4246"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2496_2476",
    x1: 56,
    y1: 30,
    x2: 56,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A",
    stopOpacity: 0.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2496_2476",
    x1: 52.1504,
    y1: 41.3734,
    x2: 62.4678,
    y2: 66.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525876,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2496_2476",
    x1: 50.2222,
    y1: -19.5,
    x2: 25.9444,
    y2: 80.8056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumCircle);
export default __webpack_public_path__ + "static/media/platinum-circle.0a8c901b521b464c901e70a90f4b0198.svg";
export { ForwardRef as ReactComponent };